
                  export default function (Component) {
                      Component.__source = "library/components/VabTabs/index.vue"
                  }
              